import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMemo } from 'react';
import { ReadyToPrepareByHourApiAdapter } from '../adapters/ReadyToPrepareByHourApiAdapter';
import type { ReadyToPrepareByHourQuery } from '../models';

const datePattern = /^\d{4}-\d{2}-\d{2}$/;

function isValidRange(q: ReadyToPrepareByHourQuery): boolean {
  if (!datePattern.test(q.date_from) || !datePattern.test(q.date_to)) return false;
  return q.date_from <= q.date_to;
}

export function useReadyToPrepareByHourReport(params: ReadyToPrepareByHourQuery | null) {
  const adapter = useMemo(() => new ReadyToPrepareByHourApiAdapter(createHttpClient(apiClientWH)), []);

  const enabled = params !== null && isValidRange(params);

  return useQuery({
    queryKey: ['ready-to-prepare-by-hour', params?.date_from, params?.date_to],
    queryFn: () => adapter.getReport(params as ReadyToPrepareByHourQuery),
    enabled,
    placeholderData: (previousData) => previousData,
    staleTime: 60 * 1000,
    retry: (failureCount, error: unknown) => {
      const msg = error instanceof Error ? error.message : String(error);
      if (msg.includes('401') || msg.includes('403')) return false;
      return failureCount < 2;
    },
  });
}
